/**
 * @flow
 * @relayHash 81c269813b4474337df7315061b2b198
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type JobStatusMutationVariables = {|
  input: {
    jobId?: ?number;
    reportId?: ?string;
    exportId?: ?string;
    type?: ?string;
    clientMutationId?: ?string;
  };
|};

export type JobStatusMutationResponse = {|
  +jobStatus: ?{|
    +job: ?{|
      +finishedOn: ?string;
      +processedOn: ?string;
      +id: string;
      +mongoId: ?string;
      +type: ?string;
      +jobId: ?number;
      +failedReason: ?string;
      +filename: ?string;
      +returnvalue: ?string;
    |};
  |};
|};
*/


/*
mutation JobStatusMutation(
  $input: JobStatusInput!
) {
  jobStatus(input: $input) {
    job {
      finishedOn
      processedOn
      id
      mongoId
      type
      jobId
      failedReason
      filename
      returnvalue
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "JobStatusInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobStatusMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "JobStatusInput!"
          }
        ],
        "concreteType": "JobStatusPayload",
        "name": "jobStatus",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "finishedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "processedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "failedReason",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "filename",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "returnvalue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "JobStatusMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "JobStatusInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "JobStatusMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "JobStatusInput!"
          }
        ],
        "concreteType": "JobStatusPayload",
        "name": "jobStatus",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "finishedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "processedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "failedReason",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "filename",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "returnvalue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation JobStatusMutation(\n  $input: JobStatusInput!\n) {\n  jobStatus(input: $input) {\n    job {\n      finishedOn\n      processedOn\n      id\n      mongoId\n      type\n      jobId\n      failedReason\n      filename\n      returnvalue\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/JobStatusMutation.graphql.js